import { render, staticRenderFns } from "./CustmerListView.vue?vue&type=template&id=601143df&lang=true"
import script from "./CustmerListView.vue?vue&type=script&lang=js"
export * from "./CustmerListView.vue?vue&type=script&lang=js"
import style0 from "./CustmerListView.vue?vue&type=style&index=0&id=601143df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports